import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { Routes } from "../../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { appConfig } from "../../../utils/configs";
import { fetchUserInfoProxy, getOrderIds } from "../../../utils/helpers/api";
import { AxiosResponse } from "axios";

const WithdRawal: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { reason } = location.state || "";
  const [state, setState] = useState<IWithRawalPageState>({
    reason: "",
  });
  const [error, setError] = useState({
    reason: "",
  });
  const [orderIds, setOrderIds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (reason) {
      setState({
        reason,
      });
    }
    document.title = '宣伝会議 : アカウント管理 | 退会';
  }, []);

  useEffect(() => {
    handleGetOrderIds();
  }, []);
  
  const handleGetOrderIds = async() => {
    setIsLoading(true);
    try {
      const response = await fetchUserInfoProxy();
      if(!response) return;
      const user_id = response?.data?.user_id;
      const res = await getOrderIds(user_id) as AxiosResponse;
      if(res.status == 200){
        setOrderIds(res?.data?.orderIds)
      }
    } catch (error) {
      console.error("Error fetching order IDs:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const renderOrderIds = (orderIds: string[]) => {
    return orderIds.map((id) => (
      <a key={id} href={`${appConfig.SPA_EVENT_WEB}/mypage/history/${id}`} target="_blank">
        {`${t("features.withdrawal.autoRenewalOrderWithId")}${id}`}
      </a>
    ));
  }

  const handleChangeValue = (field: string, value?: string) => {
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    let isValidate = true;
    let errorReasonMess = "";

    if (!state.reason) {
      isValidate = false;
      errorReasonMess = t("features.withdrawal.withdrawalRequired");
    } else if (state.reason.length > 1000) {
      isValidate = false;
      errorReasonMess = t("features.withdrawal.withdrawalMaxLength");
    } else {
      errorReasonMess = "";
    }

    setError({
      reason: errorReasonMess,
    });
    if (isValidate) {
      setState({
        reason: "",
      });
      navigate(Routes.WITHDRAWALCONFIRM, { state: { reason: state.reason } });
    }
  };

  return (
    <Box className="page__withdrawal">
      <div>
        <div className="header-tit">
          {t("features.withdrawal.title")}
        </div>
        <p className="mb8">{t("features.withdrawal.confirmationMessage")}</p>
        <div className="text-danger">
          {t("features.withdrawal.contestWarningPart0")}<br />
          {t("features.withdrawal.contestWarningPart2")}<br />
          {t("features.withdrawal.contestWarningPart3")}<br />
          {orderIds.length > 0 && (
            <p>
              {t("features.withdrawal.contestWarningPart4")}
            </p>
          )}
        </div>
        {orderIds.length > 0 && <hr />}
        {renderOrderIds(orderIds)}
        <hr />
        <div className="form-horizontal mt-3">
          <div className="form-group row">
            <label className="txt-loud mb5">{t("features.withdrawal.withdrawalReason")}</label>
            <div className="col-sm-12">
              <textarea
                rows={10}
                placeholder={t("features.withdrawal.reasonPlaceholder")}
                className="form-control w-100 px12 py6 boder_textarea"
                onChange={(e) => handleChangeValue("reason", e.target.value)}
                value={state.reason}
                disabled={orderIds.length > 0}
              />
              {error.reason && (
                <div className="text-danger">{error.reason}</div>
              )}
            </div>
          </div>
        </div>
        <hr />
        <Box className="center mt-4">
          <Button
            onClick={handleSubmit}
            className="btn form-control btn-md btn-submit"
            disabled={isLoading || orderIds.length > 0}
            variant={isLoading || orderIds.length > 0 ? "secondary" : "primary"}
          >
            {t("features.withdrawal.withdrawalButtonSubmit")}
          </Button>
        </Box>
      </div>
    </Box>
  );
};

export default WithdRawal;
